import { trackingDataApis } from '@apis/dashboard/trackingDataApis';
import { useMutation } from '@hooks/useMutation';
import { TrackingDataDeleteQuery } from '@models/TrackingData';
import { useQueryClient } from '@tanstack/react-query';

export const useDeleteTrackingData = (trackNo: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (query: TrackingDataDeleteQuery) => {
      const response = await trackingDataApis.delete('/dashboard/tracking-data/{track_no}/', {
        path: {
          track_no: trackNo,
        },
        query,
      });
      return response[204]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/tracking-data/', trackNo]);
        queryClient.invalidateQueries(['/dashboard/tracking-data/', trackNo]);
      },
    },
  );
};
